module.exports = __webpack_public_path__ + "static/left_border-049e3b7d862b7209d574f4fcacfa7bab.png";